import { axios } from '@Root/API'

export const postGoogle2fa = code => {
  return axios.post('users-google-key', { code })
}
